<!--<sd-loading-spinner ng-hide="active.revision"></sd-loading-spinner>-->
@if (viewModel?.model) {
    <div class="row assessments" [class.assessment-padding]="compactMode">
        <div [ngClass]="{ 'col-xxl-9': !compactMode }">
            <div class="assess">
                <div class="assess-heading text-start" style="display: flex">
                    <div style="flex: none; order: 1">
                        <div class="assess-title">{{ viewModel.model.revisionDesc }}</div>
                        @if (editState.editMode && editState.hasWritePermission) {
                            <div
                                class="btn-group btn-group-xs buttongroup-first buttongroup-last"
                                style="padding-left: 4px"
                            >
                                <button
                                    title="Rename"
                                    type="button"
                                    class="ace-btn btn-sm btn-secondary btn-action"
                                    [popover]="renameTemplate"
                                    [isOpen]="showPopover"
                                    [placement]="popoverDirection"
                                    (click)="originalRevisionName = viewModel.model.revisionDesc"
                                    (onHidden)="validateRevisionName()"
                                    #renamePopover="bs-popover"
                                    [outsideClick]="true"
                                >
                                    <i class="fa fa-pencil"></i> Rename
                                </button>
                                @if (
                                    currentYear &&
                                    currentYear.annualGridDetails &&
                                    currentYear.annualGridDetails.length > 1
                                ) {
                                    <button
                                        title="Reorder"
                                        type="button"
                                        class="ace-btn btn-sm btn-secondary btn-action"
                                        (click)="launchRevisionReorder()"
                                    >
                                        <i class="fa fa-sort-numeric-asc"></i> Reorder
                                    </button>
                                }
                            </div>
                        }
                    </div>
                    <div style="flex: none; order: 3; text-align: right">
                        @if (viewModel.model.hasInProgressIntakeItems && !isDocumentProcessing) {
                            <entity-in-progress-indicator
                                [entityId]="viewModel.model.annualAssessmentID"
                                [entityTypeId]="AssessmentEntityTypeId"
                                [isDocumentProcessing]="isDocumentProcessing"
                            >
                            </entity-in-progress-indicator>
                        }
                        <entity-attachments
                            [(hasAttachments)]="viewModel.model.hasAttachments"
                            buttonClass="has-icon"
                            [modalData]="viewModel.attachmentModalData"
                        >
                        </entity-attachments>
                        <entity-comments
                            [(hasComments)]="viewModel.model.hasComments"
                            buttonClass="has-icon"
                            [modalData]="viewModel.commentModalData"
                            [disabled]="!taskSummariesLoaded"
                        >
                        </entity-comments>
                    </div>
                    <div style="flex: 1 1 auto; order: 2; text-align: center">
                        @if (!viewModel.isActual()) {
                            <img src="/images/estimated-horizontal.png" alt style="height: 35px; margin-top: -3px" />
                        }
                    </div>
                </div>
                <table class="assess-table" [class.table-striped]="readOnly()" (change)="setDirty()">
                    <thead>
                        <tr>
                            <th>
                                <span>Component</span>
                            </th>
                            <th>
                                <span>AV</span>
                            </th>
                            <th>
                                <span>Ratio (%)</span>
                            </th>
                            @if (hasEditableRow() && hasRatioOverride()) {
                                <th style="padding: 0">
                                    <button class="ace-btn has-icon btn-primary btn-danger invisible" style="margin: 0">
                                        <i class="fa fa-undo"></i>
                                    </button>
                                </th>
                            }
                            <th>
                                @if (!viewTaxableValues) {
                                    <span>FMV</span>
                                } @else {
                                    <span>MV</span>
                                }
                            </th>
                            @if (hasEditableRow() && hasFmvOverride()) {
                                <th style="padding: 0">
                                    <button class="ace-btn has-icon btn-primary btn-danger invisible" style="margin: 0">
                                        <i class="fa fa-undo"></i>
                                    </button>
                                </th>
                            }
                            @if (!readOnly()) {
                                <th></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (
                            annualDetail of viewModel.model.annualAssessmentDetails
                                | componentFilter: ComponentFilter.exempt;
                            track annualDetail
                        ) {
                            <tr class="annual-assessment-row-{{ annualDetailsService.getComponentName(annualDetail) }}">
                                <td>{{ annualDetailsService.getComponentName(annualDetail, viewModel.components) }}</td>
                                <td class="assessed-value-{{ annualDetailsService.getComponentName(annualDetail) }}">
                                    @if (canEditTable()) {
                                        <assessment-input
                                            [isIdpValue]="annualDetail.isFromIdp && annualDetail.isFromIdp['av']"
                                            [value]="annualDetail.assessedValue"
                                            (valueChange)="calculate('av', annualDetail, $event)"
                                            [componentName]="annualDetailsService.getComponentName(annualDetail)"
                                            [filterFunction]="filterNumber"
                                            (resetIt)="reset(annualDetail)"
                                        >
                                        </assessment-input>
                                    }
                                    @if (!canEditTable()) {
                                        <span>{{ annualDetail.assessedValue | number: '1.0-0' }}</span>
                                    }
                                </td>
                                <td
                                    style="max-width: 130px"
                                    class="assessment-ratio-{{ annualDetailsService.getComponentName(annualDetail) }}"
                                >
                                    @if (canEditTable()) {
                                        <input
                                            type="text"
                                            class="form-control"
                                            [class.overridden]="
                                                annualDetail.ratio !== annualDetail.assessmentClassRatio.assessmentRatio
                                            "
                                            currencyMask
                                            [options]="{ allowNegative: false, precision: 3, prefix: '' }"
                                            [(ngModel)]="annualDetail.displayRatio"
                                            style="min-width: 65px"
                                            (ngModelChange)="calculate('ratio', annualDetail)"
                                            (blur)="maybeRevertToCalcRatio(annualDetail)"
                                            data-sd-assessment-component-ratio
                                            [attr.data-sd-assessment-component-name]="
                                                annualDetailsService.getComponentName(annualDetail)
                                            "
                                        />
                                    }
                                    @if (!canEditTable()) {
                                        <span
                                            [class.overridden]="
                                                annualDetail.ratio !== annualDetail.assessmentClassRatio.assessmentRatio
                                            "
                                        >
                                            {{ annualDetail.displayRatio | number: '1.3-3' }}%
                                        </span>
                                    }
                                </td>
                                @if (canEditTable() && hasRatioOverride()) {
                                    <td style="padding: 0; text-align: center">
                                        @if (annualDetail.ratio !== annualDetail.assessmentClassRatio.assessmentRatio) {
                                            <button
                                                class="ace-btn has-icon btn-primary btn-danger"
                                                style="margin: 0"
                                                (click)="undoCalcRatio_Click(annualDetail)"
                                            >
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        }
                                    </td>
                                }
                                <td>
                                    @if (canEditTable()) {
                                        <assessment-input
                                            [(isOverridden)]="annualDetail.fmvOverridden"
                                            [isIdpValue]="
                                                annualDetail.isFromIdp && annualDetail.isFromIdp['fairMarketValue']
                                            "
                                            [value]="annualDetail.fairMarketValue"
                                            (valueChange)="calculate('fairMarketValue', annualDetail, $event)"
                                            [componentName]="annualDetailsService.getComponentName(annualDetail)"
                                            [filterFunction]="filterNumber"
                                            [allowOverrides]="true"
                                            (resetIt)="reset(annualDetail)"
                                        >
                                        </assessment-input>
                                    }
                                    @if (!canEditTable()) {
                                        <span [class.overridden]="annualDetail.fmvOverridden">
                                            {{ getFairMarketValue(annualDetail) | number: '1.0-0' }}
                                        </span>
                                    }
                                </td>
                                @if (canEditTable() && hasFmvOverride()) {
                                    <td style="padding: 0; text-align: center">
                                        @if (annualDetail.fmvOverridden) {
                                            <button
                                                class="ace-btn has-icon btn-primary btn-danger"
                                                style="margin: 0"
                                                (click)="reset(annualDetail)"
                                            >
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        }
                                    </td>
                                }
                                @if (canEditTable()) {
                                    <td>
                                        <button
                                            class="ace-btn has-icon btn-primary btn-danger"
                                            style="margin: 0"
                                            (click)="deleteComponent(annualDetail)"
                                            [attr.data-sd-assessment-component-name]="
                                                annualDetailsService.getComponentName(annualDetail)
                                            "
                                        >
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                        @if (
                            (viewModel.model.annualAssessmentDetails | componentFilter: ComponentFilter.exempt).length >
                            0
                        ) {
                            <tr [ngClass]="{ total: !viewTaxableValues, 'taxable-total': showBottomLine }">
                                <td>
                                    @if (someExem() && !viewTaxableValues) {
                                        <span style="margin-right: 3px">Pre Adj</span>
                                    }
                                    Total:
                                </td>
                                <td [ngClass]="{ 'taxable-view-total': viewTaxableValues }">
                                    {{ getTotal('assessedValue', [2, 3]) | number: '1.0-0' }}
                                </td>
                                <td></td>
                                @if (hasEditableRow() && hasRatioOverride()) {
                                    <td></td>
                                }
                                <td [ngClass]="{ 'taxable-view-total': viewTaxableValues }">
                                    {{ getTotal('fairMarketValue', [2, 3]) | number: '1.0-0' }}
                                </td>
                                @if (hasEditableRow() && hasFmvOverride()) {
                                    <td></td>
                                }
                                @if (!readOnly()) {
                                    <td></td>
                                }
                            </tr>
                        }
                        @if (viewTaxableValues) {
                            @for (
                                annualDetail of viewModel.model.annualAssessmentDetails
                                    | componentFilter: ComponentFilter.alternative;
                                track annualDetail
                            ) {
                                <tr
                                    class="cap annual-assessment-row-{{
                                        annualDetailsService.getComponentName(annualDetail)
                                    }}"
                                    [ngClass]="{ 'cap-taxable': viewTaxableValues }"
                                >
                                    <td>
                                        {{ annualDetailsService.getComponentName(annualDetail, viewModel.components) }}
                                    </td>
                                    <td
                                        class="assessed-value-{{ annualDetailsService.getComponentName(annualDetail) }}"
                                    >
                                        @if (canEditTable(true)) {
                                            <assessment-input
                                                [isIdpValue]="annualDetail.isFromIdp && annualDetail.isFromIdp['av']"
                                                [value]="annualDetail.assessedValue"
                                                (valueChange)="calculate('av', annualDetail, $event)"
                                                [componentName]="annualDetailsService.getComponentName(annualDetail)"
                                                [filterFunction]="filterNumber"
                                                (resetIt)="reset(annualDetail)"
                                            >
                                            </assessment-input>
                                        }
                                        @if (!canEditTable(true)) {
                                            <span>{{ annualDetail.assessedValue | number: '1.0-0' }}</span>
                                        }
                                    </td>
                                    <td
                                        style="max-width: 130px"
                                        class="assessment-ratio-{{
                                            annualDetailsService.getComponentName(annualDetail)
                                        }}"
                                    >
                                        @if (canEditTable(true)) {
                                            <input
                                                type="number"
                                                class="form-control"
                                                [class.overridden]="
                                                    annualDetail.ratio !==
                                                    annualDetail.assessmentClassRatio.assessmentRatio
                                                "
                                                [(ngModel)]="annualDetail.displayRatio"
                                                style="min-width: 65px"
                                                (ngModelChange)="calculate('ratio', annualDetail)"
                                                (blur)="maybeRevertToCalcRatio(annualDetail)"
                                            />
                                        }
                                        @if (!canEditTable(true)) {
                                            <span
                                                [class.overridden]="
                                                    annualDetail.ratio !==
                                                    annualDetail.assessmentClassRatio.assessmentRatio
                                                "
                                            >
                                                {{ annualDetail.ratio * 100.0 | number: '1.3-3' }}%
                                            </span>
                                        }
                                    </td>
                                    @if (canEditTable(true) && hasRatioOverride()) {
                                        <td style="padding: 0; text-align: center">
                                            @if (annualDetail.ratio !== annualDetail.assessmentClassRatio.assessmentRatio) {
                                                <button
                                                    class="ace-btn has-icon btn-primary btn-danger"
                                                    style="margin: 0"
                                                    (click)="undoCalcRatio_Click(annualDetail)"
                                                >
                                                    <i class="fa fa-undo"></i>
                                                </button>
                                            }
                                        </td>
                                    }
                                    <td>
                                        @if (canEditTable(true)) {
                                            <assessment-input
                                                [isIdpValue]="
                                                    annualDetail.isFromIdp && annualDetail.isFromIdp['fairMarketValue']
                                                "
                                                [(isOverridden)]="annualDetail.fmvOverridden"
                                                [value]="annualDetail.fairMarketValue"
                                                (valueChange)="calculate('fairMarketValue', annualDetail, $event)"
                                                [componentName]="annualDetailsService.getComponentName(annualDetail)"
                                                [filterFunction]="filterNumber"
                                                [allowOverrides]="true"
                                                (resetIt)="reset(annualDetail)"
                                            >
                                            </assessment-input>
                                        }
                                        @if (!canEditTable(true)) {
                                            <span [class.overridden]="annualDetail.fmvOverridden">
                                                {{ getFairMarketValue(annualDetail) | number: '1.0-0' }}
                                            </span>
                                        }
                                    </td>
                                    @if (canEditTable(true) && hasFmvOverride()) {
                                        <td style="padding: 0; text-align: center">
                                            @if (annualDetail.fmvOverridden) {
                                                <button
                                                    class="ace-btn has-icon btn-primary btn-danger"
                                                    style="margin: 0"
                                                    (click)="reset(annualDetail)"
                                                >
                                                    <i class="fa fa-undo"></i>
                                                </button>
                                            }
                                        </td>
                                    }
                                    @if (canEditTable(true)) {
                                        <td style="padding: 0; text-align: center">
                                            <button
                                                class="ace-btn has-icon btn-primary btn-danger"
                                                style="margin: 0"
                                                (click)="deleteComponent(annualDetail)"
                                                [attr.data-sd-assessment-component-name]="
                                                    annualDetailsService.getComponentName(annualDetail)
                                                "
                                            >
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    }
                                </tr>
                            }
                        }
                        @for (
                            annualDetail of viewModel.model.annualAssessmentDetails
                                | componentFilter: ComponentFilter.nonexempt : viewTaxableValues;
                            track annualDetail
                        ) {
                            <tr class="annual-assessment-row-{{ annualDetailsService.getComponentName(annualDetail) }}">
                                <td>{{ annualDetailsService.getComponentName(annualDetail, viewModel.components) }}</td>
                                <td class="assessed-value-{{ annualDetailsService.getComponentName(annualDetail) }}">
                                    @if (canEditTable()) {
                                        <assessment-input
                                            [isIdpValue]="annualDetail.isFromIdp && annualDetail.isFromIdp['av']"
                                            [value]="annualDetail.assessedValue"
                                            (valueChange)="calculate('av', annualDetail, $event)"
                                            [componentName]="annualDetailsService.getComponentName(annualDetail)"
                                            [filterFunction]="filterNumber"
                                            [allowNegatives]="true"
                                            (resetIt)="reset(annualDetail)"
                                        >
                                        </assessment-input>
                                    }
                                    @if (!canEditTable()) {
                                        <span>{{ annualDetail.assessedValue | number: '1.0-0' }}</span>
                                    }
                                </td>
                                <td
                                    style="max-width: 130px"
                                    class="assessment-ratio-{{ annualDetailsService.getComponentName(annualDetail) }}"
                                >
                                    @if (canEditTable()) {
                                        <input
                                            type="number"
                                            class="form-control"
                                            [class.overridden]="
                                                annualDetail.ratio !== annualDetail.assessmentClassRatio.assessmentRatio
                                            "
                                            [(ngModel)]="annualDetail.displayRatio"
                                            style="min-width: 65px"
                                            (ngModelChange)="calculate('ratio', annualDetail)"
                                            (blur)="maybeRevertToCalcRatio(annualDetail)"
                                        />
                                    }
                                    @if (!canEditTable()) {
                                        <span
                                            [class.overridden]="
                                                annualDetail.ratio !== annualDetail.assessmentClassRatio.assessmentRatio
                                            "
                                        >
                                            {{ annualDetail.ratio * 100.0 | number: '1.3-3' }}%
                                        </span>
                                    }
                                </td>
                                @if (canEditTable() && hasRatioOverride()) {
                                    <td style="padding: 0; text-align: center">
                                        @if (annualDetail.ratio !== annualDetail.assessmentClassRatio.assessmentRatio) {
                                            <button
                                                class="ace-btn has-icon btn-primary btn-danger"
                                                style="margin: 0"
                                                (click)="undoCalcRatio_Click(annualDetail)"
                                            >
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        }
                                    </td>
                                }
                                <td>
                                    @if (canEditTable()) {
                                        <assessment-input
                                            [isIdpValue]="
                                                annualDetail.isFromIdp && annualDetail.isFromIdp['fairMarketValue']
                                            "
                                            [(isOverridden)]="annualDetail.fmvOverridden"
                                            [value]="annualDetail.fairMarketValue"
                                            (valueChange)="calculate('fairMarketValue', annualDetail, $event)"
                                            [componentName]="annualDetailsService.getComponentName(annualDetail)"
                                            [filterFunction]="filterNumber"
                                            [allowNegatives]="true"
                                            [allowOverrides]="true"
                                            (resetIt)="reset(annualDetail)"
                                        >
                                        </assessment-input>
                                    }
                                    @if (!canEditTable()) {
                                        <span [class.overridden]="annualDetail.fmvOverridden">
                                            {{ getFairMarketValue(annualDetail) | number: '1.0-0' }}
                                        </span>
                                    }
                                </td>
                                @if (canEditTable() && hasFmvOverride()) {
                                    <td style="padding: 0; text-align: center">
                                        @if (annualDetail.fmvOverridden) {
                                            <button
                                                class="ace-btn has-icon btn-primary btn-danger"
                                                style="margin: 0"
                                                (click)="reset(annualDetail)"
                                            >
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        }
                                    </td>
                                }
                                @if (canEditTable()) {
                                    <td style="padding: 0; text-align: center">
                                        <button
                                            class="ace-btn has-icon btn-primary btn-danger"
                                            style="margin: 0"
                                            (click)="deleteComponent(annualDetail)"
                                            [attr.data-sd-assessment-component-name]="
                                                annualDetailsService.getComponentName(annualDetail)
                                            "
                                        >
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                        @if (
                            (viewModel.model.annualAssessmentDetails | componentFilter: ComponentFilter.nonexempt)
                                .length > 0 && !viewTaxableValues
                        ) {
                            <tr class="total">
                                <td>Total:</td>
                                <td>{{ getTotal('assessedValue', [3]) | number: '1.0-0' }}</td>
                                <td></td>
                                @if (hasEditableRow() && hasRatioOverride()) {
                                    <td></td>
                                }
                                <td>{{ getTotal('fairMarketValue', [3]) | number: '1.0-0' }}</td>
                                @if (hasEditableRow() && hasFmvOverride()) {
                                    <td></td>
                                }
                                @if (!readOnly()) {
                                    <td></td>
                                }
                            </tr>
                        }
                        @if (!viewTaxableValues) {
                            @for (
                                annualDetail of viewModel.model.annualAssessmentDetails
                                    | componentFilter: ComponentFilter.alternative;
                                track annualDetail
                            ) {
                                <tr
                                    class="cap annual-assessment-row-{{
                                        annualDetailsService.getComponentName(annualDetail)
                                    }}"
                                    [ngClass]="{ 'cap-taxable': viewTaxableValues }"
                                >
                                    <td>
                                        {{ annualDetailsService.getComponentName(annualDetail, viewModel.components) }}
                                    </td>
                                    <td
                                        class="assessed-value-{{ annualDetailsService.getComponentName(annualDetail) }}"
                                    >
                                        @if (canEditTable(true)) {
                                            <assessment-input
                                                [isIdpValue]="annualDetail.isFromIdp && annualDetail.isFromIdp['av']"
                                                [value]="annualDetail.assessedValue"
                                                (valueChange)="calculate('av', annualDetail, $event)"
                                                [componentName]="annualDetailsService.getComponentName(annualDetail)"
                                                [filterFunction]="filterNumber"
                                                (resetIt)="reset(annualDetail)"
                                            >
                                            </assessment-input>
                                        }
                                        @if (!canEditTable(true)) {
                                            <span>{{ annualDetail.assessedValue | number: '1.0-0' }}</span>
                                        }
                                    </td>
                                    <td
                                        style="max-width: 130px"
                                        class="assessment-ratio-{{
                                            annualDetailsService.getComponentName(annualDetail)
                                        }}"
                                    >
                                        @if (canEditTable(true)) {
                                            <input
                                                type="number"
                                                class="form-control"
                                                [class.overridden]="
                                                    annualDetail.ratio !==
                                                    annualDetail.assessmentClassRatio.assessmentRatio
                                                "
                                                [(ngModel)]="annualDetail.displayRatio"
                                                style="min-width: 65px"
                                                (ngModelChange)="calculate('ratio', annualDetail)"
                                                (blur)="maybeRevertToCalcRatio(annualDetail)"
                                            />
                                        }
                                        @if (!canEditTable(true)) {
                                            <span
                                                [class.overridden]="
                                                    annualDetail.ratio !==
                                                    annualDetail.assessmentClassRatio.assessmentRatio
                                                "
                                            >
                                                {{ annualDetail.ratio * 100.0 | number: '1.3-3' }}%
                                            </span>
                                        }
                                    </td>
                                    @if (canEditTable(true) && hasRatioOverride()) {
                                        <td style="padding: 0; text-align: center">
                                            @if (annualDetail.ratio !== annualDetail.assessmentClassRatio.assessmentRatio) {
                                                <button
                                                    class="ace-btn has-icon btn-primary btn-danger"
                                                    style="margin: 0"
                                                    (click)="undoCalcRatio_Click(annualDetail)"
                                                >
                                                    <i class="fa fa-undo"></i>
                                                </button>
                                            }
                                        </td>
                                    }
                                    <td>
                                        @if (canEditTable(true)) {
                                            <assessment-input
                                                [isIdpValue]="
                                                    annualDetail.isFromIdp && annualDetail.isFromIdp['fairMarketValue']
                                                "
                                                [(isOverridden)]="annualDetail.fmvOverridden"
                                                [value]="annualDetail.fairMarketValue"
                                                (valueChange)="calculate('fairMarketValue', annualDetail, $event)"
                                                [componentName]="annualDetailsService.getComponentName(annualDetail)"
                                                [filterFunction]="filterNumber"
                                                [allowOverrides]="true"
                                                (resetIt)="reset(annualDetail)"
                                            >
                                            </assessment-input>
                                        }
                                        @if (!canEditTable(true)) {
                                            <span [class.overridden]="annualDetail.fmvOverridden">
                                                {{ getFairMarketValue(annualDetail) | number: '1.0-0' }}
                                            </span>
                                        }
                                    </td>
                                    @if (canEditTable(true) && hasFmvOverride()) {
                                        <td style="padding: 0; text-align: center">
                                            @if (annualDetail.fmvOverridden) {
                                                <button
                                                    class="ace-btn has-icon btn-primary btn-danger"
                                                    style="margin: 0"
                                                    (click)="reset(annualDetail)"
                                                >
                                                    <i class="fa fa-undo"></i>
                                                </button>
                                            }
                                        </td>
                                    }
                                    @if (canEditTable(true)) {
                                        <td style="padding: 0; text-align: center">
                                            <button
                                                class="ace-btn has-icon btn-primary btn-danger"
                                                style="margin: 0"
                                                (click)="deleteComponent(annualDetail)"
                                                [attr.data-sd-assessment-component-name]="
                                                    annualDetailsService.getComponentName(annualDetail)
                                                "
                                            >
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    }
                                </tr>
                            }
                        }
                    </tbody>
                    @if (viewTaxableValues && taxableValues.length !== 0) {
                        <tbody
                            class="taxable-value-dnd-list"
                            ws-dnd-list
                            [dndList]="taxableValues"
                            [dndDisabled]="!canEditTaxableValueStructure() || taxableValues.length <= 1"
                            dndListItemIdProperty="annualAssessmentTaxableValueId"
                            (dndListChange)="onTaxableValuesReordered($event)"
                        >
                            <tr class="dndPlaceholder">
                                <td colspan="10"></td>
                            </tr>
                            @for (total of taxableValues; track total; let i = $index) {
                                <tr
                                    class="taxable-totals"
                                    ws-dnd-draggable
                                    [dndDraggable]="total"
                                    dndEffectAllowed="move"
                                    [ngClass]="{
                                        'taxable-totals-first': i === 0 && hasCapComponent,
                                    }"
                                >
                                    <td>
                                        @if (canEditTaxableValueStructure()) {
                                            <span class="d-flex align-items-center" style="gap: 4px">
                                                @if (taxableValues.length > 1) {
                                                    <i
                                                        class="fa fa-grip-vertical"
                                                        style="cursor: grab; color: var(--ace-neutral-400)"
                                                        title="Drag to reorder"
                                                    ></i>
                                                }
                                                <span
                                                    helpTooltip
                                                    position="top"
                                                    [hasIcon]="true"
                                                    ws-dnd-no-drag
                                                    style="white-space: nowrap"
                                                    [contentComponent]="getTaxableInfoComponent(total)"
                                                >
                                                    Taxable{{ i !== 0 ? i + 1 : '' }}:
                                                </span>
                                                <input
                                                    type="text"
                                                    class="form-control input-sm"
                                                    style="width: 120px; margin-left: auto; text-align: right"
                                                    placeholder="Name (optional)"
                                                    maxlength="10"
                                                    ws-dnd-no-drag
                                                    [(ngModel)]="total.description"
                                                    (blur)="renameTaxableValueRow(total, total.description)"
                                                />
                                            </span>
                                        } @else {
                                            <span style="white-space: nowrap">
                                                <span
                                                    helpTooltip
                                                    position="top"
                                                    [hasIcon]="true"
                                                    [helpDisabled]="isTaxableValueInfoDisabled()"
                                                    [contentComponent]="getTaxableInfoComponent(total)"
                                                >
                                                    Taxable{{ i !== 0 ? i + 1 : '' }}{{
                                                        total.description ? ' (' + total.description + ')' : ''
                                                    }}:
                                                </span>
                                                @if (showTaxableValueCurrentRevisionHint()) {
                                                    <i
                                                        class="fa fa-info-circle"
                                                        style="margin-left: 4px"
                                                        [title]="getTaxableValueCurrentRevisionHintText()"
                                                    ></i>
                                                }
                                            </span>
                                        }
                                    </td>
                                    <td>
                                        @if (canEditTaxableValueStructure()) {
                                            <assessment-input
                                                ws-dnd-no-drag
                                                [value]="total.assessedValue"
                                                [filterFunction]="filterNumber"
                                                (valueChange)="onTaxableValueAmountEdited(total, 'assessedValue', $event)"
                                            >
                                            </assessment-input>
                                        } @else {
                                            {{ total.assessedValue | number: '1.0-0' }}
                                        }
                                    </td>
                                    <td></td>
                                    @if (hasEditableRow() && hasRatioOverride()) {
                                        <td></td>
                                    }
                                    <td>
                                        @if (canEditTaxableValueStructure()) {
                                            <assessment-input
                                                ws-dnd-no-drag
                                                [value]="total.marketValue"
                                                [filterFunction]="filterNumber"
                                                (valueChange)="onTaxableValueAmountEdited(total, 'marketValue', $event)"
                                            >
                                            </assessment-input>
                                        } @else {
                                            {{ total.marketValue | number: '1.0-0' }}
                                        }
                                    </td>
                                    @if (hasEditableRow() && hasFmvOverride()) {
                                        <td></td>
                                    }
                                    @if (!readOnly()) {
                                        <td>
                                            @if (canEditTaxableValueStructure()) {
                                                <button
                                                    type="button"
                                                    class="ace-btn has-icon btn-primary btn-danger"
                                                    style="margin: 0"
                                                    title="Delete Taxable Value"
                                                    ws-dnd-no-drag
                                                    (click)="deleteTaxableValueRow(total)"
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        </tbody>
                    }
                </table>
                @if (canAddTaxableValueRow()) {
                    <div style="float: left; width: 100%; margin: 8px 0 16px 0">
                        <button type="button" class="ace-btn btn-sm btn-primary" (click)="addTaxableValueRow()">
                            Add Taxable Value
                        </button>
                    </div>
                }
                @if (compactMode && ((editState.editMode && !viewModel.isActual()) || enableTaxableValueOverride)) {
                    <div
                        class="small-control-panel"
                        style="
                            border: solid 1px var(--ace-neutral-300);
                            box-shadow: 3px 3px 6px var(--ace-neutral-300);
                            padding: 5px 5px;
                            background-color: white;
                            border-radius: 8px;
                            margin: 0 20px 30px 20px;
                        "
                    >
                        @if (showComponentDropdown()) {
                            <span style="display: inline-block" class="btn-group" dropdown container="body">
                                <button type="button" class="ace-btn btn-sm btn-primary dropdown-toggle" dropdownToggle>
                                    Add Component
                                    <span class="caret"></span>
                                </button>
                                <ul *dropdownMenu role="menu" class="dropdown-menu">
                                    @for (
                                        type of getUnusedComponentTypes(viewModel.model.annualAssessmentDetails);
                                        track type
                                    ) {
                                        <li
                                            role="menuitem"
                                            [attr.data-sd-assessment-component-name]="type.componentName"
                                        >
                                            <a (click)="addRow(type)" class="dropdown-item" style="cursor: pointer">
                                                {{ type.componentName }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </span>
                        }
                        <span class="d-flex flex-column">
                            @if (!viewModel.isActual() && viewModel.currentYear.annualGridDetails.length <= 1) {
                                <span [class]="calcDisabled()" style="padding-left: 5px; display: inline-block">
                                    <div class="checkbox">
                                        <label class="display-type">
                                            <input
                                                type="checkbox"
                                                [(ngModel)]="viewModel.currentYear.calcProjected"
                                                (change)="autoCalculateRefresh()"
                                                [disabled]="!editState.editMode || !viewModel.currentYear.calcProjected"
                                            />Auto Calculate
                                        </label>
                                    </div>
                                </span>
                                @if (enableCapRule && hasCapComponent) {
                                    <span [class]="calcDisabled()" style="padding-left: 5px; display: inline-block">
                                        <div class="checkbox">
                                            <label class="display-type">
                                                <input
                                                    type="checkbox"
                                                    [(ngModel)]="viewModel.currentYear.calcCapProjected"
                                                    (change)="autoCalculateRefresh(true)"
                                                    [disabled]="
                                                        !editState.editMode || !viewModel.currentYear.calcCapProjected
                                                    "
                                                />Auto Calculate {{ capComponentName }}
                                            </label>
                                        </div>
                                    </span>
                                }
                            }
                            @if (enableTaxableValueOverride) {
                                <span style="padding-left: 5px; display: inline-block">
                                    <div class="checkbox">
                                        <label class="display-type">
                                            <input
                                                type="checkbox"
                                                [(ngModel)]="viewModel.currentYear.autoCalculateTaxableValue"
                                                (change)="autoCalculateTaxableValueChanged()"
                                                [disabled]="!canEditAutoCalculateTaxableValue()"
                                            />Auto Calculate TV
                                        </label>
                                    </div>
                                </span>
                            }
                            @if (isCalcTvUsingApplicable) {
                                <span
                                    style="padding-left: 5px; display: inline-block"
                                    [style.visibility]="showCalcTvUsing ? 'visible' : 'hidden'"
                                >
                                    <label class="display-type">
                                        <ng-container *ngTemplateOutlet="calcTvUsingControl"></ng-container>
                                    </label>
                                </span>
                            }
                        </span>
                    </div>
                }
                <div style="float: right" class="assessment-target-value">
                    @if (editState.editMode && viewModel.dirtyTargetValue) {
                        <div style="color: var(--ace-danger); margin-bottom: 10px">
                            @if (isTargetValueGreaterThanTotalFmv) {
                                @if (viewTaxableValues) {
                                    <div>WARNING! Target Value exceeds MV</div>
                                } @else {
                                    <div>WARNING! Target Value exceeds FMV</div>
                                }
                            }
                        </div>
                    }
                    <!-- I happen to know that compactMode is only set on document processing; if we have other cases where compactMode
                    is used, we may need to revisit this. The idea is to hide the Target Value field while on document processing. -->
                    <div style="display: table">
                        @if (!compactMode && viewModel.isLastAssessment) {
                            @if (
                                viewModel.currentYear.targetValue &&
                                (!editState.hasWritePermission || !editState.editMode)
                            ) {
                                <div class="mb-3" style="display: table-row">
                                    <span
                                        style="
                                            display: table-cell;
                                            font-weight: bold;
                                            white-space: nowrap;
                                            padding-right: 5px;
                                            padding-bottom: 5px;
                                        "
                                    >
                                        Target Value:
                                    </span>
                                    <span style="display: table-cell; text-align: right; padding-bottom: 5px">
                                        {{ viewModel.currentYear.targetValue | number: '1.0-0' }}
                                    </span>
                                </div>
                            }
                            @if (editState.hasWritePermission && editState.editMode) {
                                <div class="mb-3" style="display: table-row">
                                    <span
                                        style="
                                            display: table-cell;
                                            font-weight: bold;
                                            white-space: nowrap;
                                            padding-right: 5px;
                                            padding-bottom: 5px;
                                        "
                                        >Target Value:
                                    </span>
                                    <span style="display: table-cell; text-align: right; padding-bottom: 5px">
                                        <input
                                            type="text"
                                            class="form-control"
                                            style="font-weight: normal; color: black; width: 100px; text-align: right"
                                            [(ngModel)]="viewModel.currentYear.targetValue"
                                            (ngModelChange)="setDirty()"
                                            (blur)="targetValueChanged()"
                                            currencyMask
                                            [options]="{ allowNegative: true, precision: 0, prefix: '' }"
                                        />
                                    </span>
                                    @if (hasFmvOverride()) {
                                        <span style="padding: 5px;">
                                            <button class="ace-btn has-icon btn-primary btn-danger invisible m-0">
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        </span>
                                    }
                                    <span style="padding: 5px;">
                                        <button class="ace-btn has-icon btn-primary btn-danger invisible m-0">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </span>
                                </div>
                            }
                        }
                        @if (showEqFactorSection) {
                            <div class="mb-3" data-sd-eq-factor-container style="display: table-row">
                                <span
                                    style="
                                        display: table-cell;
                                        font-weight: bold;
                                        white-space: nowrap;
                                        padding-right: 5px;
                                        vertical-align: top;
                                    "
                                    >Eq. Factor:
                                </span>
                                <span style="display: table-cell; text-align: right">
                                    @if (showEqFactorCheckbox) {
                                        <label
                                            class="checkbox-inline"
                                            data-sd-eq-factor-checkbox
                                            style="margin-right: 0; display: block; text-align: left"
                                        >
                                            <input
                                                type="checkbox"
                                                [(ngModel)]="eqFactorCheckboxChecked"
                                                (change)="eqFactorCheckboxChanged()"
                                                [disabled]="isEqFactorReadOnly"
                                            />
                                            Applies
                                        </label>
                                    }
                                    @if (showEqFactorTextbox) {
                                        @if (isEqFactorReadOnly) {
                                            <span
                                                [class.not-actual]="isEqFactorEstimate"
                                                [class.overridden]="isEqFactorOverride"
                                                data-sd-eq-factor-input
                                                [style.margin-top.px]="showEqFactorCheckbox ? 5 : 0"
                                                style="font-weight: normal"
                                            >
                                                {{ eqFactorValue | number: '1.4-4' }}
                                            </span>
                                        } @else {
                                            <div [style.margin-top.px]="showEqFactorCheckbox ? 5 : 0">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    [class.not-actual]="isEqFactorEstimate"
                                                    [class.overridden]="isEqFactorOverride"
                                                    data-sd-eq-factor-input
                                                    style="
                                                        font-weight: normal;
                                                        display: inline-block;
                                                        width: 100px;
                                                        text-align: right;
                                                    "
                                                    [(ngModel)]="eqFactorValue"
                                                    currencyMask
                                                    [options]="{ allowNegative: false, precision: 4, prefix: '' }"
                                                />
                                                @if (showEqFactorRevert) {
                                                    <button
                                                        type="button"
                                                        class="ace-btn has-icon btn-primary btn-danger"
                                                        data-sd-eq-factor-revert
                                                        (click)="revertEqFactor()"
                                                    >
                                                        <i class="fa fa-undo"></i>
                                                    </button>
                                                }
                                            </div>
                                        }
                                    }
                                </span>
                                @if (editState.editMode) {
                                    @if (hasFmvOverride()) {
                                        <span style="padding: 5px;">
                                            <button class="ace-btn has-icon btn-primary btn-danger invisible m-0">
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        </span>
                                    }
                                    <span style="padding: 5px;">
                                        <button class="ace-btn has-icon btn-primary btn-danger invisible m-0">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </span>
                                }
                            </div>
                        }
                    </div>
                </div>
                @if (editState.editMode && appealByChanged) {
                    <div style="color: var(--ace-danger); margin-bottom: 10px">
                        @if (appealByIsInPast) {
                            <div>WARNING! Appeal By date is in the past</div>
                        }
                        @if (!appealByIsInPast && appealByIsLaterThanOriginal) {
                            <div>WARNING! The date entered is later than the system default date </div>
                        }
                    </div>
                }
                <div style="float: left">
                    <div
                        class="mb-3 appeal-by-date"
                        style="margin-bottom: 5px"
                        [class.appeal-deadline-overridden]="isDeadlineOverridden()"
                    >
                        <div style="position: relative; height: 26px">
                            <span style="font-weight: bold; margin-right: 4px">Appeal By: </span>
                            @if (
                                editState.hasWritePermission &&
                                editState.editMode &&
                                (!viewModel.isActual() || (isDocumentProcessing && isIDP))
                            ) {
                                <div
                                    style="
                                        width: 140px;
                                        display: inline-flex;
                                        position: absolute;
                                        top: -6px;
                                        left: 72px;
                                    "
                                >
                                    <!--" && !taskSummaries?.CompletedDateTime">-->
                                    <weissman-datetime
                                        [class.date-time-override]="!areDeadlinesEqual()"
                                        (change)="onAppealDeadlineChanged()"
                                        [(inputDate)]="viewModel.model.appealDeadline"
                                        (inputDateBlur)="revertDateCheck()"
                                        [dateOnly]="true"
                                    ></weissman-datetime>
                                </div>
                            } @else {
                                <span class="deadline-read-only" style="margin-right: 6px">
                                    {{ viewModel.model.appealDeadline | weissmanDateFormat: true }}
                                </span>
                            }
                            @if (
                                editState.hasWritePermission &&
                                editState.editMode &&
                                (!viewModel.isActual() || (isDocumentProcessing && isIDP)) &&
                                isDeadlineOverridden()
                            ) {
                                <button
                                    class="ace-btn has-icon btn-primary btn-danger"
                                    style="margin: 0; position: absolute; right: -42px; top: -3px"
                                    (click)="resetAppealDeadline_click()"
                                >
                                    <i class="fa fa-undo"></i>
                                </button>
                            }
                            @if (!taskSummaries && taskSummariesLoaded) {
                                <i
                                    class="fa fa-chain-broken"
                                    style="position: absolute; font-size: 18px; margin-top: 8px; margin-left: 6px"
                                    aria-hidden="true"
                                ></i>
                            }
                        </div>
                        @if (taskSummaries) {
                            <div style="height: 26px; display: flex; gap: 3px">
                                <span style="font-weight: bold; margin-right: 5px">Status:</span>
                                @if (taskSummaries?.CompletedDateTime) {
                                    <i class="fa fa-check" style="color: var(--ace-success); font-size: 18px"></i>
                                }
                                <a (click)="launchTaskModal()" style="cursor: pointer" class="anchor-color"
                                    >{{ taskSummaries?.Status }}
                                    @if (taskSummaries.CompletedDateTime) {
                                        <span>
                                            {{ taskSummaries.CompletedDateTime | weissmanDateFormat: true : 'Central' }}
                                        </span>
                                    }
                                </a>
                            </div>
                        }
                        @if (!taskSummaries && taskSummariesLoaded) {
                            <div style="min-height: 26px">
                                <span style="font-weight: bold; margin-right: 4px">Status: </span>N/A - No
                                Responsibility <br />
                                @if (editState.hasWritePermission) {
                                    <div class="display-type checkbox">
                                        <label>
                                            <input
                                                type="checkbox"
                                                [checked]="viewModel.isActual()"
                                                [disabled]="viewModel.currentYear.calcProjected || !editState.editMode"
                                                (change)="changeActual()"
                                            />Actual
                                        </label>
                                    </div>
                                }
                            </div>
                        }
                        @if (
                            hasAllocationFeature &&
                            isPPParcel &&
                            allocationTaskSummaries &&
                            allocationTaskSummariesLoaded
                        ) {
                            <div style="height: 26px">
                                <div>
                                    <span style="font-weight: bold; margin-right: 8px">Allocation Status:</span>
                                    <a (click)="launchAllocationTaskModal()" style="cursor: pointer">
                                        {{ allocationTaskSummaries.Status }}
                                    </a>
                                </div>
                                <div>
                                    <button type="button" class="ace-btn btn-sm btn-primary" (click)="goToAllocation()">
                                        {{ hasAllocation ? 'Continue' : 'Begin' }} Allocation
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        @if (!compactMode) {
            <div class="col-xxl-3 ps-4" style="padding-right: 20px">
                @if (
                    editState.editMode ||
                    (!viewModel.isActual() && currentYear.annualGridDetails.length <= 1) ||
                    enableTaxableValueOverride
                ) {
                    <div
                        style="
                            border: solid 1px var(--ace-neutral-300);
                            box-shadow: var(--ace-shadow);
                            padding: 5px 5px;
                            background-color: white;
                            border-radius: 8px;
                            width: fit-content;
                        "
                    >
                        <!-- Action Buttons -->
                        <div class="d-flex">
                            @if (editState.hasWritePermission && !readOnly()) {
                                <button class="ace-btn btn-sm btn-primary btn-danger w-100" (click)="deleteAssessment()"
                                    >Delete Asmt
                                </button>
                            }
                        </div>
                        <!-- Add component button -->
                        @if (showComponentDropdown()) {
                            <div class="btn-group buttongroup-first buttongroup-last w-100" dropdown container="body">
                                <button
                                    type="button"
                                    class="ace-btn btn-sm btn-primary dropdown-toggle w-100"
                                    dropdownToggle
                                >
                                    Add Component
                                    <span class="caret"></span>
                                </button>
                                <ul *dropdownMenu role="menu" class="dropdown-menu">
                                    @for (
                                        type of getUnusedComponentTypes(viewModel.model.annualAssessmentDetails);
                                        track type
                                    ) {
                                        <li
                                            role="menuitem"
                                            [attr.data-sd-assessment-component-name]="type.componentName"
                                        >
                                            <a (click)="addRow(type)" class="dropdown-item" style="cursor: pointer">
                                                {{ type.componentName }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        }
                        <!-- Checkboxes -->
                        <div class="d-flex flex-column" style="padding-left: 5px">
                            @if (!viewModel.isActual() && currentYear.annualGridDetails.length <= 1) {
                                <div class="checkbox" [class]="calcDisabled()">
                                    <label class="display-type">
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="viewModel.currentYear.calcProjected"
                                            (change)="autoCalculateRefresh()"
                                            [disabled]="!editState.editMode"
                                        />Auto Calculate
                                    </label>
                                </div>
                                @if (enableCapRule && hasCapComponent) {
                                    <div class="checkbox" [class]="calcDisabled()">
                                        <label class="display-type">
                                            <input
                                                type="checkbox"
                                                [(ngModel)]="viewModel.currentYear.calcCapProjected"
                                                (change)="autoCalculateRefresh(true)"
                                                [disabled]="!editState.editMode"
                                            />Auto Calculate {{ capComponentName }}
                                        </label>
                                    </div>
                                }
                            }
                            @if (enableTaxableValueOverride) {
                                <div class="checkbox">
                                    <label class="display-type">
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="viewModel.currentYear.autoCalculateTaxableValue"
                                            (change)="autoCalculateTaxableValueChanged()"
                                            [disabled]="!canEditAutoCalculateTaxableValue()"
                                        />Auto Calculate TV
                                    </label>
                                </div>
                            }
                            <!-- Hidden, not removed, while Auto Calculate TV is unchecked: it keeps the panel width but takes no height. -->
                            @if (isCalcTvUsingApplicable) {
                                <div
                                    class="form-group"
                                    style="margin-bottom: 0"
                                    [style.visibility]="showCalcTvUsing ? 'visible' : 'hidden'"
                                    [style.height]="showCalcTvUsing ? null : '0'"
                                    [style.overflow]="showCalcTvUsing ? null : 'hidden'"
                                >
                                    <label class="display-type">
                                        <ng-container *ngTemplateOutlet="calcTvUsingControl"></ng-container>
                                    </label>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}

<ng-template #calcTvUsingControl>
    Calc TV Using:
    @if (canEditCalcTvUsing()) {
        <select
            class="form-select form-select-sm"
            style="display: inline-block; width: auto"
            [(ngModel)]="viewModel.currentYear.calcTVUsing"
            (change)="calcTvUsingChanged()"
        >
            <option [ngValue]="systemLogic">System Logic</option>
            <option
                [ngValue]="priorYearSetup"
                [disabled]="isPriorYearSetupOptionDisabled()"
                [title]="
                    isPriorYearSetupOptionDisabled()
                        ? 'The prior Tax Year has no taxable values to carry forward.'
                        : ''
                "
            >
                Prior Year Setup
            </option>
        </select>
    } @else {
        {{ calcTvUsingLabel }}
    }
</ng-template>

<ng-template #renameTemplate>
    <div class="radio" [class.disabled]="viewModel.isActual()">
        <label>
            <input
                type="radio"
                [(ngModel)]="revisionName"
                (change)="setRevisionName(true)"
                name="optionsRadios"
                value="Forecast"
                [disabled]="viewModel.isActual()"
            />Forecast
        </label>
    </div>
    <div class="radio" style="display: block">
        <label>
            <input
                type="radio"
                [(ngModel)]="revisionName"
                (change)="setRevisionName(true)"
                name="optionsRadios"
                value="Original"
            />Original
        </label>
    </div>
    <div class="radio" style="display: block">
        <label>
            <input
                type="radio"
                [(ngModel)]="revisionName"
                (change)="setRevisionName(true)"
                name="optionsRadios"
                value="Final"
            />Final
        </label>
    </div>
    <div class="radio" style="display: block">
        <label>
            <input
                type="radio"
                [(ngModel)]="revisionName"
                (change)="setRevisionName(false)"
                name="optionsRadios"
                value="Other"
            />Other
            @if (revisionName === 'Other') {
                <input
                    type="text"
                    [(ngModel)]="revisionOtherName"
                    (blur)="renamePopover.hide()"
                    (keyup.enter)="blurPopover($event)"
                    (change)="setRevisionName()"
                    name="revisionDesc"
                    maxlength="10"
                />
            }
        </label>
    </div>
</ng-template>
